import React from "react";
import { Leaf } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-border bg-secondary/40">
      <div className="container-civic py-12 grid grid-cols-1 md:grid-cols-12 gap-8">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2">
            <span className="w-8 h-8 grid place-items-center bg-primary text-primary-foreground rounded-sm">
              <Leaf size={16} />
            </span>
            <span className="font-display text-lg font-extrabold tracking-tight">
              fără hârtie<span className="text-[#00D670]">.</span>ro
            </span>
          </div>
          <p className="mt-3 max-w-md text-sm text-foreground/70 leading-relaxed">
            O platformă cetățenească pentru ca proiectele bune să ajungă, fără hârtie și fără filtre, în atenția autorităților locale.
          </p>
        </div>
        <div className="md:col-span-3">
          <div className="label-overline mb-3">Navighează</div>
          <ul className="space-y-2 text-sm">
            <li><a className="hover:text-primary" href="/proiecte">Proiecte</a></li>
            <li><a className="hover:text-primary" href="/despre">Despre</a></li>
            <li><a className="hover:text-primary" href="/dashboard">Voturile mele</a></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <div className="label-overline mb-3">Contact</div>
          <p className="text-sm text-foreground/70">contact@farahartie.ro</p>
          <p className="text-sm text-foreground/70 mt-2">
            © {new Date().getFullYear()} fără hârtie.ro · Construit pentru transparență.
          </p>
        </div>
      </div>
    </footer>
  );
}
